export const LEAD_API_URL = "https://api.eibempresas.com";
export const RESULTADOS_URL = "https://resultados.simuladorbpf.com";

export const sendEvent = async function (_id, eventName, workflow = false) {
    if (!eventName) return;

    try {
        const postData = { eventName };
        let url = `${LEAD_API_URL}/onboarding/set-event/${_id}`;

        if (!_id) url = `/event/${eventName}`;
        if (workflow) postData.iw = true;

        await fetch(url, {
            method: "POST",
            headers: { "Content-Type": "application/json" },
            body: JSON.stringify(postData)
        });
    } catch (e) {
        console.log(e);
    }
}